import { Box } from '@mui/material';
import Image from 'next/image';
import type { ReactNode } from 'react';
import { effects } from 'design-system/tokens/effects';
import { bentoTokens } from '../bento-tokens';

interface BannerStateProps {
  imageUrl: string;
  alt: string;
  onImageClick?: () => void;
  blur?: boolean;
  badgesSlot?: ReactNode;
}

/**
 * Bento Banner State (N=1 Image)
 * 
 * Single image stretches to fill 100% width and height.
 * Clicking opens the fullscreen gallery lightbox.
 */
export function BentoBannerState({
  imageUrl,
  alt,
  onImageClick,
  blur,
  badgesSlot,
}: BannerStateProps) {
  return (
    <Box
      data-testid="gallery-bento-banner"
      onClick={onImageClick}
      role="button"
      tabIndex={0}
      onKeyDown={e => e.key === 'Enter' && onImageClick?.()}
      sx={{
        position: 'relative',
        width: '100%',
        height: bentoTokens.height,
        borderRadius: bentoTokens.borderRadius.main,
        overflow: 'hidden',
        cursor: 'pointer',
        filter: blur ? effects.blur[100] : 'none',
      }}
    >
      <Image
        src={imageUrl}
        alt={alt}
        fill
        sizes={bentoTokens.imageSizes.banner}
        style={{ objectFit: 'cover' }}
        priority
      />
      {badgesSlot && (
        <Box
          sx={{
            position: 'absolute',
            top: bentoTokens.overlay.badges,
            left: bentoTokens.overlay.badges,
            zIndex: bentoTokens.zIndex.badges,
          }}
        >
          {badgesSlot}
        </Box>
      )}
    </Box>
  );
}
